var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M6.375 0.75H0.25V14.75H10.75V5.125H6.375V0.75ZM7.25 0.75V4.25H10.75L7.25 0.75ZM4.84375 12.7812V12.125V10.5938H3.3125H2.65625V9.28125H3.3125H4.84375V7.75V7.09375H6.15625V7.75V9.28125H7.6875H8.34375V10.5938H7.6875H6.15625V12.125V12.7812H4.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContract);
export default __webpack_public_path__ + "static/media/add_contract.ed18499e73f18d45c08f2d8ab1b37937.svg";
export { ForwardRef as ReactComponent };